var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfessionalsNewContactRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00a0df;}.cls-2{fill:#0072b2;}.cls-3{fill:#fff;}.cls-4{fill:#bfebff;}.cls-5{fill:#71c2ea;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "professionals_new_contact"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 300.98,
    cy: 300,
    r: 300
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "479.19 248.69 479.19 248.9 299.97 376.27 120.78 248.92 120.78 248.72 300 121.34 479.19 248.69"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 163.38,
    y: 120.78,
    width: 273.21,
    height: 325.99,
    rx: 20
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "479.22 248.72 479.22 479.22 120.78 479.22 120.78 248.92 299.97 376.27 479.19 248.9 479.19 248.69 479.22 248.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M479.22,479v.19H120.78V479L282,364.46a31.1,31.1,0,0,1,36,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M303.13,218.88a31.48,31.48,0,0,1,16.08,4.32A31.89,31.89,0,0,1,331,235,31.47,31.47,0,0,1,335.28,251v10.07a11.46,11.46,0,0,1-11.51,11.52H239.3a11.47,11.47,0,0,1-11.51-11.52V251A31.48,31.48,0,0,1,232.11,235a31.87,31.87,0,0,1,11.75-11.76,31.48,31.48,0,0,1,16.08-4.32H264a41.86,41.86,0,0,0,35,0Zm-21.59-7.67a30.46,30.46,0,0,1-15.48-4.08A29.89,29.89,0,0,1,254.9,196a31.41,31.41,0,0,1,0-31,29.93,29.93,0,0,1,11.16-11.15,31.39,31.39,0,0,1,30.95,0A29.93,29.93,0,0,1,308.17,165a31.41,31.41,0,0,1,0,31A29.89,29.89,0,0,1,297,207.13,30.45,30.45,0,0,1,281.54,211.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M333.1,316.55a22.39,22.39,0,0,1-22.36-22.37V280.32H296.46a21.87,21.87,0,0,1,0-43.73h14.28V222.75a22.37,22.37,0,1,1,44.73,0v13.84h17a21.87,21.87,0,0,1,0,43.73h-17v13.86A22.4,22.4,0,0,1,333.1,316.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M333.1,207.88A14.91,14.91,0,0,1,348,222.75v21.34h24.46a14.37,14.37,0,0,1,0,28.73H348v21.36a14.91,14.91,0,0,1-14.87,14.87h0a14.91,14.91,0,0,1-14.86-14.87V272.82H296.46a14.37,14.37,0,0,1,0-28.73h21.78V222.75a14.91,14.91,0,0,1,14.86-14.87h0m0-15a29.9,29.9,0,0,0-29.86,29.87v6.34h-6.78a29.37,29.37,0,0,0,0,58.73h6.78v6.36a29.87,29.87,0,1,0,59.73,0v-6.36h9.46a29.37,29.37,0,0,0,0-58.73H363v-6.34a29.9,29.9,0,0,0-29.87-29.87Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfessionalsNewContactRequest);
export default __webpack_public_path__ + "static/media/professionals_new_contact_request.6b71b9a252877cdf32911b92c85cdc4c.svg";
export { ForwardRef as ReactComponent };